import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Partner {
  id: string
  email: string
  name: string
  type: 'Services Partner' | 'MSSP Partner' | 'Reseller Partner'
  tier: 'Standard' | 'Premium' | 'Elite'
  isAdmin: boolean
}

interface AuthState {
  partner: Partner | null
  isAuthenticated: boolean
  isLoading: boolean
  setPartner: (partner: Partner) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      partner: null,
      isAuthenticated: false,
      isLoading: true,
      setPartner: (partner) => set({ partner, isAuthenticated: true, isLoading: false }),
      setLoading: (loading) => set({ isLoading: loading }),
      logout: () => set({ partner: null, isAuthenticated: false, isLoading: false }),
    }),
    {
      name: 'flarebase-auth',
    }
  )
)
